import React, { useEffect, useState, useRef, useContext, useCallback } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { URLBunge, URLBungeAvatar } from "./Componentes/Config";
import { LogAcesso, ReactHtmlParser } from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";
import Avatar from 'avataaars'
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaPerfilAvatar,
  BtGravarAlteracoes,
  DivListaAvatar,
  NomeTipoAvatar,
  BtOpcaoAvatar,
  TextCarregando,
  BtVoltar,
  DivSaldo,
  DivBtsNoticiaNovidades,
  BtNoticiaNovidades,
  BtNoticiaNovidadesSelecionado,
  ValorLojinha,
  BtCompraItem,
  ItemClubeOfertas,
  ImgBannerClubeOfertas,
  ImgLogoClubeOfertas,
  TextoCupom,
  ValorLojinhaCupom,
  BtAcessarCupom
} from './Estilos'

import ImgBtSetaVoltar from "./Images/BtSeta.png";
import ImgBtMoedas from "./Images/ico_moedas.png";

function Lojinha(props) {

  const history = useHistory();
  const [ Loading, setLoading ] = useState(true);

  const [ NomeEvento, setNomeEvento ] = useState("Minha Bunge Vendas");
  const [ Token, setToken ] = useState(localStorage.getItem("c_token"));

  useEffect(() => {
    if (Token === null) {
        history.push({ pathname: '/', state: {} });
    } else {
        LogAcesso(Token, "Lojinha")
    }
    PegaAvatars()
  }, []);


  const [TipoSelecionado, setTipoSelecionado] = useState(0);
  function MudaPesquisa(Tipo) {
      setTipoSelecionado(Tipo)

      if(Tipo === 0){
        LogAcesso(Token, "Lojinha / Avatar")
      } else {
        LogAcesso(Token, "Lojinha / Clube de Vantagens")
      }
  }

  const Bt_skinColor = (props) => {
    var BgSelecionado = '#DDD';
    if(skinColor == props.produto) {
      BgSelecionado = '#043c54';
    }
    return <>
    <BtCompraItem onClick={()=>{ ComprarAvatar(props.pontos, props.produtoId) }}>
      <BtOpcaoAvatar>
        {/* {skinColor} */}
        <Avatar
              style = {{width: '100px', height: '100px'}}
              avatarStyle = 'Circle'
              topType = {'.'}
              accessoriesType = {'.'}
              hatColor = {'.'}
              hairColor = {'.'}
              facialHairType = {'.'}
              facialHairColor = {'.'}
              clotheType = {'.'}
              clotheColor = {'.'}
              graphicType = {'.'}
              eyeType = {'.'}
              eyebrowType = {'.'}
              mouthType = {'.'}
              skinColor = {props.produto}
          />
      </BtOpcaoAvatar>
      <ValorLojinha> <img src={ImgBtMoedas} /> <div>{props.pontos}</div> </ValorLojinha>
    </BtCompraItem>
    </>
  }

  const Bt_topType = (props) => {
    var BgSelecionado = '#DDD';
    if(topType == props.produto) {
      BgSelecionado = '#043c54';
    }
    return <>
    <BtCompraItem onClick={()=>{ ComprarAvatar(props.pontos, props.produtoId) }}>
      <BtOpcaoAvatar BgItem={BgSelecionado}>
          <Avatar
            style = {{width: '100px', height: '100px'}}
            avatarStyle = 'Circle'
            topType = {props.produto}
            accessoriesType = {'.'}
            hatColor = {'.'}
            hairColor = {'.'}
            facialHairType = {'.'}
            facialHairColor = {'.'}
            clotheType = {'.'}
            clotheColor = {'.'}
            graphicType = {'.'}
            eyeType = {'.'}
            eyebrowType = {'.'}
            mouthType = {'.'}
            skinColor = {'.'}
          />
      </BtOpcaoAvatar>
      <ValorLojinha> <img src={ImgBtMoedas} /> <div>{props.pontos}</div> </ValorLojinha>
    </BtCompraItem>
    </>
  }

  const Bt_hatColor = (props) => {
    var BgSelecionado = '#DDD';
    if(hatColor == props.produto) {
      BgSelecionado = '#043c54';
    }
    var CorChapeu = '';  
    switch (props.produto) {
      case 'Black':
        CorChapeu = '#262E33'; break;
      case 'Blue01':
        CorChapeu = '#65C9FF'; break;
      case 'Blue02':
        CorChapeu = '#5199E4'; break;
      case 'Blue03':
        CorChapeu = '#25557C'; break;
      case 'Gray01':
        CorChapeu = '#E6E6E6'; break;
      case 'Gray02':
        CorChapeu = '#929598'; break;
      case 'Heather':
        CorChapeu = '#3C4F5C'; break;
      case 'PastelBlue':
        CorChapeu = '#B1E2FF'; break;
      case 'PastelGreen':
        CorChapeu = '#A7FFC4'; break;
      case 'PastelOrange':
        CorChapeu = '#FFDEB5'; break;
      case 'PastelRed':
        CorChapeu = '#FFAFB9'; break;
      case 'PastelYellow':
        CorChapeu = '#FFFFB1'; break;
      case 'Pink':
        CorChapeu = '#FF488E'; break;
      case 'Red':
        CorChapeu = '#FF5C5C'; break;
      case 'White':
        CorChapeu = '#FFFFFF'; break;
    }
    return <>
    <BtCompraItem onClick={()=>{ ComprarAvatar(props.pontos, props.produtoId) }}>
      <BtOpcaoAvatar BgItem={BgSelecionado} >
        <div style={{ backgroundColor: CorChapeu, width: 70, height: 70, borderRadius: 4, margin: 3 }}></div>
      </BtOpcaoAvatar>
      <ValorLojinha> <img src={ImgBtMoedas} /> <div>{props.pontos}</div> </ValorLojinha>
    </BtCompraItem>
    </>
  }

  const Bt_hairColor = (props) => {
    var BgSelecionado = '#DDD';
    if(hairColor == props.produto) {
      BgSelecionado = '#043c54';
    }

    var CorCabelo = '';  
    switch (props.produto) {
      case 'Auburn':
        CorCabelo = '#A55728'; break;
      case 'Black':
        CorCabelo = '#2C1B18'; break;
      case 'Blonde':
        CorCabelo = '#B58143'; break;
      case 'BlondeGolden':
        CorCabelo = '#D6B370'; break;
      case 'Brown':
        CorCabelo = '#724133'; break;
      case 'BrownDark':
        CorCabelo = '#4A312C'; break;
      case 'PastelPink':
        CorCabelo = '#F59797'; break;
      case 'Platinum':
        CorCabelo = '#ECDCBF'; break;
      case 'Red':
        CorCabelo = '#C93305'; break;
      case 'SilverGray':
        CorCabelo = '#E8E1E1'; break;
    }
    return <>
    <BtCompraItem onClick={()=>{ ComprarAvatar(props.pontos, props.produtoId) }}>
    <BtOpcaoAvatar BgItem={BgSelecionado}>
      <div style={{ backgroundColor: CorCabelo, width: 70, height: 70, borderRadius: 4, margin: 3 }}></div>
    </BtOpcaoAvatar>
      <ValorLojinha> <img src={ImgBtMoedas} /> <div>{props.pontos}</div> </ValorLojinha>
    </BtCompraItem>
    </>
  }

  const Bt_facialHairColor = (props) => {
    var BgSelecionado = '#DDD';
    if(facialHairColor == props.produto) {
      BgSelecionado = '#043c54';
    }
    var CorBarba = '';
    switch (props.produto) {
      case 'Auburn':
        CorBarba = '#A55728'; break;
      case 'Black':
        CorBarba = '#2C1B18'; break;
      case 'Blonde':
        CorBarba = '#B58143'; break;
      case 'BlondeGolden':
        CorBarba = '#D6B370'; break;
      case 'Brown':
        CorBarba = '#724133'; break;
      case 'BrownDark':
        CorBarba = '#4A312C'; break;
      case 'Platinum':
        CorBarba = '#ECDCBF'; break;
      case 'Red':
        CorBarba = '#C93305'; break;
    }
    return <>
    <BtCompraItem onClick={()=>{ ComprarAvatar(props.pontos, props.produtoId) }}>
    <BtOpcaoAvatar BgItem={BgSelecionado}>
      <div style={{ backgroundColor: CorBarba, width: 70, height: 70, borderRadius: 4, margin: 3 }}></div>
    </BtOpcaoAvatar>
      <ValorLojinha> <img src={ImgBtMoedas} /> <div>{props.pontos}</div> </ValorLojinha>
    </BtCompraItem>
    </>
  }

  const Bt_clotheColor = (props) => {
    var BgSelecionado = '#DDD';
    if(clotheColor == props.produto) {
      BgSelecionado = '#043c54';
    }
    var CorRoupa = '';  
    switch (props.produto) {
      case 'Black':
        CorRoupa = '#262E33'; break;
      case 'Blue01':
        CorRoupa = '#65C9FF'; break;
      case 'Blue02':
        CorRoupa = '#5199E4'; break;
      case 'Blue03':
        CorRoupa = '#25557C'; break;
      case 'Gray01':
        CorRoupa = '#E6E6E6'; break;
      case 'Gray02':
        CorRoupa = '#929598'; break;
      case 'Heather':
        CorRoupa = '#3C4F5C'; break;
      case 'PastelBlue':
        CorRoupa = '#B1E2FF'; break;
      case 'PastelGreen':
        CorRoupa = '#A7FFC4'; break;
      case 'PastelOrange':
        CorRoupa = '#FFDEB5'; break;
      case 'PastelRed':
        CorRoupa = '#FFAFB9'; break;
      case 'PastelYellow':
        CorRoupa = '#FFFFB1'; break;
      case 'Pink':
        CorRoupa = '#FF488E'; break;
      case 'Red':
        CorRoupa = '#FF5C5C'; break;
      case 'White':
        CorRoupa = '#FFFFFF'; break;
    }  
    return <>
    <BtCompraItem onClick={()=>{ ComprarAvatar(props.pontos, props.produtoId) }}>
    <BtOpcaoAvatar BgItem={BgSelecionado}>
      <div style={{ backgroundColor: CorRoupa, width: 70, height: 70, borderRadius: 4, margin: 3 }}></div>
    </BtOpcaoAvatar>
      <ValorLojinha> <img src={ImgBtMoedas} /> <div>{props.pontos}</div> </ValorLojinha>
    </BtCompraItem>
    </>
  }

  const Bt_facialHairType = (props) => {
    var BgSelecionado = '#DDD';
    if(facialHairType == props.produto) {
      BgSelecionado = '#043c54';
    }
    return <>
    <BtCompraItem onClick={()=>{ ComprarAvatar(props.pontos, props.produtoId) }}>
      <BtOpcaoAvatar BgItem={BgSelecionado}>
          <Avatar
            style = {{width: '100px', height: '100px'}}
            avatarStyle = 'Circle'
            topType = {'NoHair'}
            accessoriesType = {'.'}
            hatColor = {'.'}
            hairColor = {'.'}
            facialHairType = {props.produto}
            facialHairColor = {'.'}
            clotheType = {'.'}
            clotheColor = {'.'}
            graphicType = {'.'}
            eyeType = {'.'}
            eyebrowType = {'.'}
            mouthType = {'.'}
            skinColor = {'.'}
          />
      </BtOpcaoAvatar>
      <ValorLojinha> <img src={ImgBtMoedas} /> <div>{props.pontos}</div> </ValorLojinha>
    </BtCompraItem>
    </>
  }

  const Bt_accessoriesType = (props) => {
    var BgSelecionado = '#DDD';
    if(accessoriesType == props.produto) {
      BgSelecionado = '#043c54';
    }
    return <>
    <BtCompraItem onClick={()=>{ ComprarAvatar(props.pontos, props.produtoId) }}>
      <BtOpcaoAvatar BgItem={BgSelecionado}>
          <Avatar
            style = {{width: '100px', height: '100px'}}
            avatarStyle = 'Circle'
            topType = {'NoHair'}
            accessoriesType = {props.produto}
            hatColor = {'.'}
            hairColor = {'.'}
            facialHairType = {'.'}
            facialHairColor = {'.'}
            clotheType = {'.'}
            clotheColor = {'.'}
            graphicType = {'.'}
            eyeType = {'.'}
            eyebrowType = {'.'}
            mouthType = {'.'}
            skinColor = {'.'}
          />
      </BtOpcaoAvatar>
      <ValorLojinha> <img src={ImgBtMoedas} /> <div>{props.pontos}</div> </ValorLojinha>
    </BtCompraItem>
    </>
  }

  const Bt_clotheType = (props) => {
    var BgSelecionado = '#DDD';
    if(clotheType == props.produto) {
      BgSelecionado = '#043c54';
    }
    return <>
    <BtCompraItem onClick={()=>{ ComprarAvatar(props.pontos, props.produtoId) }}>
      <BtOpcaoAvatar BgItem={BgSelecionado}>
          <Avatar
            style = {{width: '100px', height: '100px'}}
            avatarStyle = 'Circle'
            topType = {'NoHair'}
            accessoriesType = {'.'}
            hatColor = {'.'}
            hairColor = {'.'}
            facialHairType = {'.'}
            facialHairColor = {'.'}
            clotheType = {props.produto}
            clotheColor = {'.'}
            graphicType = {'.'}
            eyeType = {'.'}
            eyebrowType = {'.'}
            mouthType = {'.'}
            skinColor = {'.'}
          />
      </BtOpcaoAvatar>
      <ValorLojinha> <img src={ImgBtMoedas} /> <div>{props.pontos}</div> </ValorLojinha>
    </BtCompraItem>
    </>
  }

  const Bt_eyeType = (props) => {
    var BgSelecionado = '#DDD';
    if(eyeType == props.produto) {
      BgSelecionado = '#043c54';
    }
    return <>
    <BtCompraItem onClick={()=>{ ComprarAvatar(props.pontos, props.produtoId) }}>
      <BtOpcaoAvatar BgItem={BgSelecionado}>
          <Avatar
            style = {{width: '100px', height: '100px'}}
            avatarStyle = 'Circle'
            topType = {'NoHair'}
            accessoriesType = {'.'}
            hatColor = {'.'}
            hairColor = {'.'}
            facialHairType = {'.'}
            facialHairColor = {'.'}
            clotheType = {'.'}
            clotheColor = {'.'}
            graphicType = {'.'}
            eyeType = {props.produto}
            eyebrowType = {'.'}
            mouthType = {'.'}
            skinColor = {'.'}
          />
      </BtOpcaoAvatar>
      <ValorLojinha> <img src={ImgBtMoedas} /> <div>{props.pontos}</div> </ValorLojinha>
    </BtCompraItem>
    </>
  }

  const Bt_eyebrowType = (props) => {
    var BgSelecionado = '#DDD';
    if(eyebrowType == props.produto) {
      BgSelecionado = '#043c54';
    }
    return <>
    <BtCompraItem onClick={()=>{ ComprarAvatar(props.pontos, props.produtoId) }}>
      <BtOpcaoAvatar BgItem={BgSelecionado}>
          <Avatar
            style = {{width: '100px', height: '100px'}}
            avatarStyle = 'Circle'
            topType = {'NoHair'}
            accessoriesType = {'.'}
            hatColor = {'.'}
            hairColor = {'.'}
            facialHairType = {'.'}
            facialHairColor = {'.'}
            clotheType = {'.'}
            clotheColor = {'.'}
            graphicType = {'.'}
            eyeType = {'.'}
            eyebrowType = {props.produto}
            mouthType = {'.'}
            skinColor = {'.'}
          />
      </BtOpcaoAvatar>
      <ValorLojinha> <img src={ImgBtMoedas} /> <div>{props.pontos}</div> </ValorLojinha>
    </BtCompraItem>
    </>
  }

  const Bt_mouthType = (props) => {
    var BgSelecionado = '#DDD';
    if(mouthType == props.produto) {
      BgSelecionado = '#043c54';
    }
    return <>
    <BtCompraItem onClick={()=>{ ComprarAvatar(props.pontos, props.produtoId) }}>
      <BtOpcaoAvatar BgItem={BgSelecionado}>
          <Avatar
            style = {{width: '100px', height: '100px'}}
            avatarStyle = 'Circle'
            topType = {'NoHair'}
            accessoriesType = {'.'}
            hatColor = {'.'}
            hairColor = {'.'}
            facialHairType = {'.'}
            facialHairColor = {'.'}
            clotheType = {'.'}
            clotheColor = {'.'}
            graphicType = {'.'}
            eyeType = {'.'}
            eyebrowType = {'.'}
            mouthType = {props.produto}
            skinColor = {'.'}
          />
      </BtOpcaoAvatar>
      <ValorLojinha> <img src={ImgBtMoedas} /> <div>{props.pontos}</div> </ValorLojinha>
    </BtCompraItem>
    </>
  }

  async function PegaAvatars() {
    
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    

    // fetch(`${URLBunge}/api/Avatar/ListaConquistado`, requestOptions)
    fetch(`${URLBunge}/api/Avatar/ListaAComprar`, requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log(result);
        setLoading(false);
        for(var prop in result.avataresAComprar) {
          // console.log('passou', prop);
          if(result.avataresAComprar[prop].categoria === "topType") {
            var Conteudo = {
              "produtoId": result.avataresAComprar[prop].produtoId,
              "categoria": result.avataresAComprar[prop].categoria,
              "produto": result.avataresAComprar[prop].produto,
              "pontos": result.avataresAComprar[prop].pontos
            }
            setItems_topType(Items_topType => [...Items_topType, Conteudo])
          }
          if(result.avataresAComprar[prop].categoria === "accessoriesType") {
            var Conteudo = {
              "produtoId": result.avataresAComprar[prop].produtoId,
              "categoria": result.avataresAComprar[prop].categoria,
              "produto": result.avataresAComprar[prop].produto,
              "pontos": result.avataresAComprar[prop].pontos
            }
            setItems_accessoriesType(Items_accessoriesType => [...Items_accessoriesType, Conteudo])
          }
          if(result.avataresAComprar[prop].categoria === "hatColor") {
            var Conteudo = {
              "produtoId": result.avataresAComprar[prop].produtoId,
              "categoria": result.avataresAComprar[prop].categoria,
              "produto": result.avataresAComprar[prop].produto,
              "pontos": result.avataresAComprar[prop].pontos
            }
            setItems_hatColor(Items_hatColor => [...Items_hatColor, Conteudo])
          }
          if(result.avataresAComprar[prop].categoria === "hairColor") {
            var Conteudo = {
              "produtoId": result.avataresAComprar[prop].produtoId,
              "categoria": result.avataresAComprar[prop].categoria,
              "produto": result.avataresAComprar[prop].produto,
              "pontos": result.avataresAComprar[prop].pontos
            }
            setItems_hairColor(Items_hairColor => [...Items_hairColor, Conteudo])
          }
          if(result.avataresAComprar[prop].categoria === "facialHairType") {
            var Conteudo = {
              "produtoId": result.avataresAComprar[prop].produtoId,
              "categoria": result.avataresAComprar[prop].categoria,
              "produto": result.avataresAComprar[prop].produto,
              "pontos": result.avataresAComprar[prop].pontos
            }
            setItems_facialHairType(Items_facialHairType => [...Items_facialHairType, Conteudo])
          }
          if(result.avataresAComprar[prop].categoria === "facialHairColor") {
            var Conteudo = {
              "produtoId": result.avataresAComprar[prop].produtoId,
              "categoria": result.avataresAComprar[prop].categoria,
              "produto": result.avataresAComprar[prop].produto,
              "pontos": result.avataresAComprar[prop].pontos
            }
            setItems_facialHairColor(Items_facialHairColor => [...Items_facialHairColor, Conteudo])
          }
          if(result.avataresAComprar[prop].categoria === "clotheType") {
            var Conteudo = {
              "produtoId": result.avataresAComprar[prop].produtoId,
              "categoria": result.avataresAComprar[prop].categoria,
              "produto": result.avataresAComprar[prop].produto,
              "pontos": result.avataresAComprar[prop].pontos
            }
            setItems_clotheType(Items_clotheType => [...Items_clotheType, Conteudo])
          }
          if(result.avataresAComprar[prop].categoria === "clotheColor") {
            var Conteudo = {
              "produtoId": result.avataresAComprar[prop].produtoId,
              "categoria": result.avataresAComprar[prop].categoria,
              "produto": result.avataresAComprar[prop].produto,
              "pontos": result.avataresAComprar[prop].pontos
            }
            setItems_clotheColor(Items_clotheColor => [...Items_clotheColor, Conteudo])
          }
          if(result.avataresAComprar[prop].categoria === "graphicType") {
            var Conteudo = {
              "produtoId": result.avataresAComprar[prop].produtoId,
              "categoria": result.avataresAComprar[prop].categoria,
              "produto": result.avataresAComprar[prop].produto,
              "pontos": result.avataresAComprar[prop].pontos
            }
            setItems_graphicType(Items_graphicType => [...Items_graphicType, Conteudo])
          }
          if(result.avataresAComprar[prop].categoria === "eyeType") {
            var Conteudo = {
              "produtoId": result.avataresAComprar[prop].produtoId,
              "categoria": result.avataresAComprar[prop].categoria,
              "produto": result.avataresAComprar[prop].produto,
              "pontos": result.avataresAComprar[prop].pontos
            }
            setItems_eyeType(Items_eyeType => [...Items_eyeType, Conteudo])
          }
          if(result.avataresAComprar[prop].categoria === "eyebrowType") {
            var Conteudo = {
              "produtoId": result.avataresAComprar[prop].produtoId,
              "categoria": result.avataresAComprar[prop].categoria,
              "produto": result.avataresAComprar[prop].produto,
              "pontos": result.avataresAComprar[prop].pontos
            }
            setItems_eyebrowType(Items_eyebrowType => [...Items_eyebrowType, Conteudo])
          }
          if(result.avataresAComprar[prop].categoria === "mouthType") {
            var Conteudo = {
              "produtoId": result.avataresAComprar[prop].produtoId,
              "categoria": result.avataresAComprar[prop].categoria,
              "produto": result.avataresAComprar[prop].produto,
              "pontos": result.avataresAComprar[prop].pontos
            }
            setItems_mouthType(Items_mouthType => [...Items_mouthType, Conteudo])
          }
          if(result.avataresAComprar[prop].categoria === "skinColor") {
            var Conteudo = {
              "produtoId": result.avataresAComprar[prop].produtoId,
              "categoria": result.avataresAComprar[prop].categoria,
              "produto": result.avataresAComprar[prop].produto,
              "pontos": result.avataresAComprar[prop].pontos
            }
            setItems_skinColor(Items_skinColor => [...Items_skinColor, Conteudo])
          }          
        }
      })
      .catch(error => console.log('error', error));
    
  }


  const [Items_topType, setItems_topType] = useState([]);
  const [Items_accessoriesType, setItems_accessoriesType] = useState([]);
  const [Items_hatColor, setItems_hatColor] = useState([]);
  const [Items_hairColor, setItems_hairColor] = useState([]);
  const [Items_facialHairType, setItems_facialHairType] = useState([]);
  const [Items_facialHairColor, setItems_facialHairColor] = useState([]);
  const [Items_clotheType, setItems_clotheType] = useState([]);
  const [Items_clotheColor, setItems_clotheColor] = useState([]);
  const [Items_graphicType, setItems_graphicType] = useState([]);
  const [Items_eyeType, setItems_eyeType] = useState([]);
  const [Items_eyebrowType, setItems_eyebrowType] = useState([]);
  const [Items_mouthType, setItems_mouthType] = useState([]);
  const [Items_skinColor, setItems_skinColor] = useState([]);

  useEffect(() => {    
    set_topType(localStorage.getItem("c_avatar_topType"));
    set_accessoriesType(localStorage.getItem("c_avatar_accessoriesType"));
    set_hatColor(localStorage.getItem("c_avatar_hatColor"));
    set_hairColor(localStorage.getItem("c_avatar_hairColor"));
    set_facialHairType(localStorage.getItem("c_avatar_facialHairType"));
    set_facialHairColor(localStorage.getItem("c_avatar_facialHairColor"));
    set_clotheType(localStorage.getItem("c_avatar_clotheType"));
    set_clotheColor(localStorage.getItem("c_avatar_clotheColor"));
    set_graphicType(localStorage.getItem("c_avatar_graphicType"));
    set_eyeType(localStorage.getItem("c_avatar_eyeType"));
    set_eyebrowType(localStorage.getItem("c_avatar_eyebrowType"));
    set_mouthType(localStorage.getItem("c_avatar_mouthType"));
    set_skinColor(localStorage.getItem("c_avatar_skinColor"));

    setId_topType(localStorage.getItem("id_avatar_topType"));
    setId_accessoriesType(localStorage.getItem("id_avatar_accessoriesType"));
    setId_hatColor(localStorage.getItem("id_avatar_hatColor"));
    setId_hairColor(localStorage.getItem("id_avatar_hairColor"));
    setId_facialHairType(localStorage.getItem("id_avatar_facialHairType"));
    setId_facialHairColor(localStorage.getItem("id_avatar_facialHairColor"));
    setId_clotheType(localStorage.getItem("id_avatar_clotheType"));
    setId_clotheColor(localStorage.getItem("id_avatar_clotheColor"));
    setId_graphicType(localStorage.getItem("id_avatar_graphicType"));
    setId_eyeType(localStorage.getItem("id_avatar_eyeType"));
    setId_eyebrowType(localStorage.getItem("id_avatar_eyebrowType"));
    setId_mouthType(localStorage.getItem("id_avatar_mouthType"));
    setId_skinColor(localStorage.getItem("id_avatar_skinColor"));

  },[]);





  const [ topType, set_topType ] = useState('');
  const [ accessoriesType, set_accessoriesType ] = useState('');
  const [ hatColor, set_hatColor ] = useState('');
  const [ hairColor, set_hairColor ] = useState('');
  const [ facialHairType, set_facialHairType ] = useState('');
  const [ facialHairColor, set_facialHairColor ] = useState('');
  const [ clotheType, set_clotheType ] = useState('');
  const [ clotheColor, set_clotheColor ] = useState('');
  const [ graphicType, set_graphicType ] = useState('');
  const [ eyeType, set_eyeType ] = useState('');
  const [ eyebrowType, set_eyebrowType ] = useState('');
  const [ mouthType, set_mouthType ] = useState('');
  const [ skinColor, set_skinColor ] = useState('');

  const [Id_topType, setId_topType] = useState('');
  const [Id_accessoriesType, setId_accessoriesType] = useState('');
  const [Id_hatColor, setId_hatColor] = useState('');
  const [Id_hairColor, setId_hairColor] = useState('');
  const [Id_facialHairType, setId_facialHairType] = useState('');
  const [Id_facialHairColor, setId_facialHairColor] = useState('');
  const [Id_clotheType, setId_clotheType] = useState('');
  const [Id_clotheColor, setId_clotheColor] = useState('');
  const [Id_graphicType, setId_graphicType] = useState('');
  const [Id_eyeType, setId_eyeType] = useState('');
  const [Id_eyebrowType, setId_eyebrowType] = useState('');
  const [Id_mouthType, setId_mouthType] = useState('');
  const [Id_skinColor, setId_skinColor] = useState('');

  const [ SaldoAcumulado, setSaldoAcumulado ] = useState(0);
  const [ SaldoResgatado, setSaldoResgatado ] = useState(0);
  const [ SaldoAtual, setSaldoAtual ] = useState(0);

  useEffect(() => {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
  
    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
  
    // fetch(`${URLBunge}/api/Saldo/Busca`, requestOptions)
    //   .then(response => response.json())
    //   .then(result => {        
    //     setSaldoAcumulado(result.saldoBonus);
    //     setSaldoResgatado(result.saldoPremios);
    //     setSaldoAtual(result.saldoAtual);        
    //   })
    //   .catch(error => console.log('error', error));

  },[]);

  function ComprarAvatar(pontos, produto) {

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='AlertaJs'>
            {/*<h1>ATENÇÃO</h1>*/}
            <p>Para confirmar seu resgate, clique em SIM.<br/>Tem certeza que deseja este item?</p>
            <button className="BotaoAcessarBD" onClick={() => { onClose(); }}>NÃO</button>
            <button className="BotaoAcessarBD" onClick={() => { onClose(); ConfirmaCompraAvatar(pontos, produto) }}>SIM</button>
          </div>
        );
      },
      closeOnEscape: false,
      closeOnClickOutside: false,
    });

  }

  function ConfirmaCompraAvatar(pontos, produto) {
      console.log(pontos +' - '+ produto)

      var myHeaders = new Headers();
      myHeaders.append("Authorization", "bearer " + Token);
      myHeaders.append("Content-Type", "application/json");
    
      var raw = JSON.stringify({
        "pontos": pontos,
        "produtoId": produto,
        "origem": 23071
      });
    
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };
    
      fetch(`${URLBunge}/api/Avatar/Compra`, requestOptions)
        .then(response => response.json())
        .then(result => {
          // console.log(result);
          if(result.sucesso === true) {

              confirmAlert({
                customUI: ({ onClose }) => {
                  return (
                    <div className='AlertaJs'>
                      <p>{result.mensagem}</p>
                      <button className="BotaoAcessarBD" onClick={() => { onClose(); history.push({ pathname: 'Home', state: {} }) }}>OK</button>
                    </div>
                  );
                },
                closeOnEscape: false,
                closeOnClickOutside: false,
              });

          } else {

            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <div className='AlertaJs'>
                    <p>{result.mensagem}</p>
                    <button className="BotaoAcessarBD" onClick={() => { onClose(); history.push({ pathname: 'Home', state: {} }) }}>OK</button>
                  </div>
                );
              },
              closeOnEscape: false,
              closeOnClickOutside: false,
            });

          }
        })
        .catch(error => console.log('error', error));

  }




  const [ClubeOfertas, setClubeOfertas] = useState([]);

  useEffect(() => { 

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
  
    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
  
    fetch(`${URLBunge}/api/ClubeOfertas/ListarClubeOferta`, requestOptions)
      .then(response => response.json())
      .then(result => {
        if(result.sucesso === true) {
          setClubeOfertas(result.lista);
          // console.log(result.lista);
        }
      })
      .catch(error => console.log('error', error));

  },[]);


  const renderClubeOfertas = useCallback(( item, index ) => {
      return <>
      <ItemClubeOfertas key={index}>

        { item.oft_Banner !== null && item.oft_Banner !== 'null' ?
          <ImgBannerClubeOfertas src={`http://www.plataformaomnion.com.br/ofertas/mini/${item.oft_Banner}`} />
        : null }

        { item.oft_Imagem !== null || item.oft_Imagem !== 'null' ?
          <ImgLogoClubeOfertas> <img src={`http://www.plataformaomnion.com.br/ofertas/${item.oft_Imagem}`} /> </ImgLogoClubeOfertas>
        : null }

        <TextoCupom>
          <div className={'NomeCupom'}>
            {item.oft_Nome}
            {item.oft_Desconto == null || item.oft_Desconto == 'null' ? null : <div>{item.oft_Desconto}</div> }
          </div>
          <div className={'DescCupom'}>{item.oft_Descricao}</div>

          { item.ja_Pegou === false ?
            <ValorLojinhaCupom onClick={()=>{ ComprarDesconto(item.oft_Id, item.oft_Pontos, item.oft_Link) }}> <img src={ImgBtMoedas} /> <div>{item.oft_Pontos}</div> </ValorLojinhaCupom>
          :
            <BtAcessarCupom href={item.oft_Link} target={'_blank'}> <div>ACESSAR</div> </BtAcessarCupom>
          }

        </TextoCupom>

      </ItemClubeOfertas>
      </>
  }, []);




  function ComprarDesconto(produto, pontos, link) {
    
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='AlertaJs'>
            {/*<h1>ATENÇÃO</h1>*/}
            <p>Para confirmar seu resgate, clique em SIM.<br/>Tem certeza que deseja este item?</p>
            <button className="BotaoAcessarBD" onClick={() => { onClose(); }}>NÃO</button>
            <button className="BotaoAcessarBD" onClick={() => { onClose(); ConfirmaCompraCupom(pontos, produto, link) }}>SIM</button>
          </div>
        );
      },
      closeOnEscape: false,
      closeOnClickOutside: false,
    });

  }



  function ConfirmaCompraCupom(pontos, produto, link) {
    console.log(pontos +' - '+ produto +' - '+ link)

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    myHeaders.append("Content-Type", "application/json");
  
    var raw = JSON.stringify({
      "pontos": pontos,
      "idOferta": produto,
      "origem": 23071
    });
  
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
  
    fetch(`${URLBunge}/api/ClubeOfertas/ResgatarOferta`, requestOptions)
      .then(response => response.json())
      .then(result => {
        // console.log(result);
        if(result.sucesso === true) {

            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <div className='AlertaJs'>
                    <p>{result.mensagem} xxx</p>
                    <button className="BotaoAcessarBD" onClick={() => {
                      onClose();
                      history.push({ pathname: 'Home', state: {} });
                      window.open(link);
                      }}>OK</button>
                  </div>
                );
              },
              closeOnEscape: false,
              closeOnClickOutside: false,
            });

        } else {

          confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <div className='AlertaJs'>
                  <p>{result.mensagem} yyy</p>
                  <button className="BotaoAcessarBD" onClick={() => { onClose(); history.push({ pathname: 'Home', state: {} }) }}>OK</button>
                </div>
              );
            },
            closeOnEscape: false,
            closeOnClickOutside: false,
          });

        }
      })
      .catch(error => console.log('error', error));

  }


  return (
    <>  
        <CabecalhoPagina NomeEvento={NomeEvento} />
        {Loading === true ? <Carregando /> : null }

        <BackgroundImg Background={''} BackgroundMob={''} bgcolor={'#FFFFFF'}>
            
            <ColunaPerfilAvatar>
                <div className={'AreaColunaPerfilAvatar'}>

                    <TitNoticias>Lojinha</TitNoticias>
                    <Clear />

                    <BtVoltar onClick={()=>history.push({ pathname: '/home', state: { } })} style={{marginLeft: 'auto', marginRight: 'auto'}}>
                      <img src={ImgBtSetaVoltar} /> <div>VOLTAR</div>
                    </BtVoltar>
                    <br/>
                    <Clear />

                    <DivSaldo>
                      <div>Atual: <span>{SaldoAtual.toLocaleString()}</span></div>
                      <div>Acumulado: <span>{SaldoAcumulado.toLocaleString()}</span></div>
                      <div>Resgatado: <span>{SaldoResgatado.toLocaleString()}</span></div>
                    </DivSaldo>

                    <DivBtsNoticiaNovidades>
                      {TipoSelecionado == 0 ?
                        <BtNoticiaNovidadesSelecionado>AVATAR</BtNoticiaNovidadesSelecionado>
                      :
                        <BtNoticiaNovidades onClick={()=>MudaPesquisa(0)}>AVATAR</BtNoticiaNovidades>
                      }
                      {TipoSelecionado == 1 ?
                        <BtNoticiaNovidadesSelecionado>CLUBE DE VANTAGENS</BtNoticiaNovidadesSelecionado>
                      :
                        <BtNoticiaNovidades onClick={()=>MudaPesquisa(1)}>CLUBE DE VANTAGENS</BtNoticiaNovidades>
                      }                      
                    </DivBtsNoticiaNovidades>

                    <Clear />

                    {TipoSelecionado == 0 ?
                    <>
                    Use suas moedas para liberar itens extras para o seu avatar.
                    <br/>
                    <Clear />


                    { Items_skinColor.length > 0 ? <>
                    <NomeTipoAvatar>COR DA PELE</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                          Items_skinColor.map((item, index) => {
                            return <>
                              <Bt_skinColor
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                                pontos={item.pontos}
                              />
                            </>
                          })
                      }
                    </DivListaAvatar>
                    </> : null } <Clear />

                    { Items_topType.length > 0 ? <>
                    <NomeTipoAvatar>CABELO / CHAPÉU / GORRO</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                          Items_topType.map((item, index) => {
                            return <>
                              <Bt_topType
                                Props={''}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                                pontos={item.pontos}
                              />
                            </>
                          })
                      }
                    </DivListaAvatar>
                    </> : null } <Clear />
                    
                    { Items_hatColor.length > 0 ? <>
                    <NomeTipoAvatar>COR DO CHAPÉU / GORRO</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                          Items_hatColor.map((item, index) => {
                            return <>
                              <Bt_hatColor
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                                pontos={item.pontos}
                              />
                            </>
                          })
                      }
                    </DivListaAvatar>
                    </> : null } <Clear />
                  
                    { Items_hairColor.length > 0 ? <>
                    <NomeTipoAvatar>COR DO CABELO</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                          Items_hairColor.map((item, index) => {
                            return <>
                              <Bt_hairColor
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                                pontos={item.pontos}
                              />
                            </>
                          })
                      }
                    </DivListaAvatar>
                    </> : null } <Clear />
                    
                    { Items_facialHairType.length > 0 ? <>
                    <NomeTipoAvatar>BARBA / BIGODE</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                          Items_facialHairType.map((item, index) => {
                            return <>
                              <Bt_facialHairType
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                                pontos={item.pontos}
                              />
                            </>
                          })
                      }
                    </DivListaAvatar>
                    </> : null } <Clear />
                    
                    { Items_facialHairColor.length > 0 ? <>
                    <NomeTipoAvatar>COR DA BARBA / BIGODE</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                          Items_facialHairColor.map((item, index) => {
                            return <>
                              <Bt_facialHairColor
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                                pontos={item.pontos}
                              />
                            </>
                          })
                      }
                    </DivListaAvatar>
                    </> : null } <Clear />
                    
                    { Items_accessoriesType.length > 0 ? <>
                    <NomeTipoAvatar>ACESSÓRIOS</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                          Items_accessoriesType.map((item, index) => {
                            return <>
                              <Bt_accessoriesType
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                                pontos={item.pontos}
                              />
                            </>
                          })
                      }
                    </DivListaAvatar>
                    </> : null } <Clear />

                    { Items_clotheType.length > 0 ? <>
                    <NomeTipoAvatar>ROUPA</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                          Items_clotheType.map((item, index) => {
                            return <>
                              <Bt_clotheType
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                                pontos={item.pontos}
                              />
                            </>
                          })
                      }
                    </DivListaAvatar>
                    </> : null } <Clear />
                    
                    { Items_clotheColor.length > 0 ? <>
                    <NomeTipoAvatar>COR DA ROUPA</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                          Items_clotheColor.map((item, index) => {
                            return <>
                              <Bt_clotheColor
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                                pontos={item.pontos}
                              />
                            </>
                          })
                      }
                    </DivListaAvatar>
                    </> : null } <Clear />
                    
                    { Items_eyeType.length > 0 ? <>
                    <NomeTipoAvatar>OLHOS</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                          Items_eyeType.map((item, index) => {
                            return <>
                              <Bt_eyeType
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                                pontos={item.pontos}
                              />
                            </>
                          })
                      }
                    </DivListaAvatar>
                    </> : null } <Clear />

                    { Items_eyebrowType.length > 0 ? <>
                    <NomeTipoAvatar>SOBRANCELHA</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                          Items_eyebrowType.map((item, index) => {
                            return <>
                              <Bt_eyebrowType
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                                pontos={item.pontos}
                              />
                            </>
                          })
                      }
                    </DivListaAvatar>
                    </> : null } <Clear />

                    { Items_mouthType.length > 0 ? <>
                    <NomeTipoAvatar>BOCA</NomeTipoAvatar>
                    <DivListaAvatar>
                      {
                          Items_mouthType.map((item, index) => {
                            return <>
                              <Bt_mouthType
                                Props={props}
                                produtoId={item.produtoId}
                                categoria={item.categoria}
                                produto={item.produto}
                                pontos={item.pontos}
                              />
                            </>
                          })
                      }
                    </DivListaAvatar>
                    </> : null } <Clear />

                    </>
                    :
                    <>
                    No Clube de Vantagens você tem tratamento diferenciado, pode realizar compras com descontos e aproveitar os benefícios de diversas parcerias incríveis. Use suas moedas para resgatar esses descontos e vantagens! Confira abaixo e clique na loja desejada para conhecer os benefícios.
                    <br /><br /><br />

                    { ClubeOfertas.length > 0 ?   
                        ClubeOfertas.map((item, index) => {
                          return renderClubeOfertas(item, index)
                        })
                      :
                        <div>Carregando...</div>
                    }
                    </>
                    }




                </div>  
            </ColunaPerfilAvatar>
            
            <MenuPrinc Pagina="Pesquisas" />
         </BackgroundImg>
    </>
  );

}

export default Lojinha;
